<template>
  <div class="loader-component" :class="{ fixed, absolute, 'color-red': colorRed, transparent }">
    <div></div>
  </div>
</template>

<script>
  export default {
    name: 'Loader',
    props: {
      fixed: Boolean,
      absolute: Boolean,
      colorRed: {
        type: Boolean,
        default: false,
      },
      transparent: {
        type: Boolean,
        default: false,
      },
    },
  }
</script>

<style lang="less" scoped>
.loader-component {
  position: static;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;

  div {
    width: 50px;
    height: 50px;
    margin: 2rem;
    border-radius: 50%;
    border: 0.3rem solid @color-primary;
    border-top-color: rgba(@color-primary, 0.2);
    animation: 2s spin infinite ease;

    @keyframes spin {
      from {
        transform: rotate(0);
      }
      to {
        transform: rotate(360deg);
      }
    }

  }

  &.color-red {
    div {
      border: 0.3rem solid @color-error;
      border-top-color: rgba(@color-error, 0.2);
    }
  }

  &.absolute:not(.transparent),
  &.fixed:not(.transparent) {
    background-color: rgba(255, 255, 255, 0.8);
  }

  &.absolute {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }

  &.fixed {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }
}
</style>
